import React, { useState } from 'react';

export function GetTitle(
  ctgy: string,
  title: string,
  subTitle: string,
  SearchText: string = '',
  SelectSearch: string = 'subject',
  disableSearch: boolean = true,
  searchFunction: () => void,
  SearchTextFunction: (param: string) => void,
  SelectSearchFunction: (param: string) => void
) {
  const [searchText, setSearchText] = useState<string>('');
  const [selectSearch, setSelectSearch] = useState<string>('');

  const options = [
    {
      value: 'all',
      name: '전체',
    },
    {
      value: 'subject',
      name: '제목',
    },
    {
      value: 'content',
      name: '내용',
    },
    {
      value: 'writer',
      name: '작성자',
    },
  ];

  return (
    <>
      <div className="title">
        <h2>{title}</h2>
        <p>{subTitle}</p>
      </div>
      {disableSearch ? (
        <div className="table-header">
          <div className="search">
            <div className="selectbox">
              <select
                name=""
                id=""
                onChange={(dom) => {
                  setSelectSearch(dom.target.value);
                  SelectSearchFunction(selectSearch);
                }}
              >
                {options.map((it) => (
                  <option value={it.value} key={it.value}>
                    {it.name}
                  </option>
                ))}
              </select>
            </div>
            <input
              type="search"
              value={searchText}
              onChange={(dom) => {
                setSearchText(dom.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  SearchTextFunction(searchText);
                  SelectSearchFunction(selectSearch);
                  searchFunction();
                }
              }}
            />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              onClick={() => {
                SearchTextFunction(searchText);
                SelectSearchFunction(selectSearch);
                searchFunction();
              }}
            >
              <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
            </svg>
          </div>
        </div>
      ) : (
        ''
      )}
    </>
  );
}
